import {Box, Center, Flex, Text} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {AlertDialog} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC, PropsWithChildren, useMemo, useState} from 'react';
import {ICategoryByProviderResponse, ProviderTypeEnum} from 'types';
import LinkUI from 'ui/LinkUI';
import NextImageUI from 'ui/NextImage';

interface Props extends ICategoryByProviderResponse {
  onClick?: any;
  providerType?: ProviderTypeEnum;
  isActive?: boolean;
  activeCategory?: string;
  onChange: (categorySlug: string) => void;
  isFromMainPage?: boolean;
}

export const Category: FC<PropsWithChildren<Props>> = ({
  onClick,
  name,
  slug,
  img_for_slider_thumbnail,
  children,
  activeCategory,
  onChange,
  providerType,
  isFromMainPage,
}) => {
  const [isShowAlert, setIsShowAlert] = useState(false);
  const slugForRequestToServer = slug;
  const isActive = activeCategory === slugForRequestToServer;
  const {t} = useTranslation();

  const toggleAlertDialog = () => {
    setIsShowAlert((prev) => !prev);
  };

  const updateUrl = () => {
    if (onClick) {
      onClick(slugForRequestToServer);
    } else {
      onChange(slugForRequestToServer);
    }
  };

  const handleClick = () => {
    if (name !== '18+') {
      updateUrl();
    } else {
      toggleAlertDialog();
    }
  };

  const onConfirm = () => {
    updateUrl();
  };

  const provider = useMemo(
    () => (providerType === ProviderTypeEnum.RESTAURANT ? 'restaurants' : 'markets'),
    [providerType],
  );

  const linkHref =
    provider === 'restaurants'
      ? `/category/${slug}`
      : `/${provider}?categorySlug=${slug}${isFromMainPage ? '&products=true' : ''}`;
  return (
    <>
      <LinkUI href={name === '18+' || onClick ? undefined : linkHref}>
        <Center
          cursor="pointer"
          mt="auto"
          borderRadius="16px"
          minW="90px"
          w={['40px', '100px']}
          _hover={!onClick ? {bg: colors.pink, color: colors.white} : {}}
          color={isActive ? colors.white : colors.black}
          bg={isActive ? colors.pink : colors.white}
          onClick={handleClick}
        >
          <Flex flexDirection="column" alignItems="center" justifyContent="space-between" pb="12px">
            {children || (
              <Center w="full">
                <Box w={['70%', '100%']} h={['70%', '100px']}>
                  <NextImageUI src={img_for_slider_thumbnail} width={90} height={90} alt={`Category ${slug}`} />
                </Box>
              </Center>
            )}
            <Text
              fontSize={['14px', '16px']}
              fontWeight={600}
              overflowWrap="anywhere"
              overflow="hidden"
              px="3px"
              h="24px"
              textAlign="center"
            >
              {name}
            </Text>
          </Flex>
        </Center>
      </LinkUI>
      {isShowAlert && (
        <AlertDialog
          title={t('YOU_HAVE_18_YEARS')}
          isOpen={isShowAlert}
          onClose={toggleAlertDialog}
          onConfirm={onConfirm}
          successButtonValue={t('yes')}
          cancelButtonValue={t('no')}
        />
      )}
    </>
  );
};
